import { useImmer } from 'use-immer'
import s from './NotesModal.scss'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import { InputContainer } from 'components/ideal-core-ui'
import moment from 'moment'

const NotesModal = ({ showNotesModal, toggleNotesModal, row, selectedWeek, handleNotesChange }) => {
  const [notes, setNotes] = useImmer(row.notes)
  return (
    <Modal
      keyboard={false}
      backdrop="static"
      isOpen={showNotesModal}
      toggle={toggleNotesModal}
      size="md"
    >
      <ModalHeader toggle={toggleNotesModal} className={s.modalHeader}>
        Description of Work activity
      </ModalHeader>
      <ModalBody>
        <p>{row.readOnly ? 'View' : 'Add'} daily description of work activity</p>
        {selectedWeek.map(
          (day, i) =>
            row.hours[i] > 0 && (
              <div key={i} style={{ margin: '20px 0' }}>
                <label className={s.label}>
                  <strong>{moment(day).format('DD ')}</strong>
                  {moment(day).format('ddd')}
                </label>
                <InputContainer
                  type="text"
                  classname={s.input}
                  cb={value => {
                    setNotes(draft => {
                      draft[i] = value
                    })
                  }}
                  text={notes[i]}
                  isDisabled={row.readOnly || !row.hours[i]}
                  placeholder={row.readOnly ? '' : 'Add description'}
                />
              </div>
            )
        )}
      </ModalBody>
      <ModalFooter>
        {!row.readOnly && (
          <Button
            className={s.saveBtn}
            onClick={() => {
              handleNotesChange(notes, row)
              toggleNotesModal()
            }}
            disabled={row.readOnly}
          >
            Save
          </Button>
        )}
        <Button color="secondary" onClick={toggleNotesModal}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default NotesModal
